import apiCall from '@/utils/api';
import qs from 'qs';

const state = { submission: {} };

const mutations = {
	set_submission(state, payload) {
		state.submission = payload;
	},
};

const getters = {};

const actions = {
	latest_submission: ({ rootState, commit }) => {
		const options = {
			method: 'GET',
			headers: { 'content-type': 'application/x-www-form-urlencoded' },
			url: `api/v1/commissioner/latest_submission`,
			params: {
				room_id: rootState.room.id,
			},
		};

		apiCall(options).then(({ data }) => {
			commit('set_submission', data);
		});
	},
	reject_pick: ({ state, commit }) => {
		const player_id = state.submission.pick_data['player_id'];
		const picker_id = state.submission.pick_data['room_user_id'];

		const options = {
			method: 'POST',
			headers: { 'content-type': 'application/x-www-form-urlencoded' },
			data: qs.stringify({
				player_id,
				picker_id,
			}),
			url: `api/v1/commissioner/reject_player`,
		};

		apiCall(options).then(({ data }) => {
			commit('set_submission', {});
		});
	},
	confirm_pick: ({ state, commit }) => {
		const player_id = state.submission.pick_data['player_id'];
		const picker_id = state.submission.pick_data['room_user_id'];

		const options = {
			method: 'POST',
			headers: { 'content-type': 'application/x-www-form-urlencoded' },
			data: qs.stringify({
				player_id,
				picker_id,
			}),
			url: `api/v1/commissioner/confirm_player`,
		};

		apiCall(options).then(({ data }) => {
			commit('set_submission', {});
		});
	},
	start_draft: ({ rootState, commit }) => {
		const options = {
			method: 'POST',
			headers: { 'content-type': 'application/x-www-form-urlencoded' },
			params: {
				room_id: rootState.room.id,
			},
			url: `api/v1/commissioner/start_draft`,
		};

		return apiCall(options).then(({ data }) => {
			commit('set_current_picker', data.current_picker);
			commit('set_current_round', data.current_round);
		});
	},
	restart_draft: ({ rootState, commit }) => {
		const options = {
			method: 'POST',
			headers: { 'content-type': 'application/x-www-form-urlencoded' },
			params: {
				room_id: rootState.room.id,
			},
			url: `api/v1/commissioner/restart_draft`,
		};

		apiCall(options).then(({ data }) => {
			commit('set_current_picker', data.current_picker);
			commit('set_current_round', data.current_round);
			commit('set_picks', []);
		});
	},
};

export default {
	state,
	mutations,
	getters,
	actions,
};
